
import Jimp from 'jimp'
import domtoimage from 'dom-to-image'

import download from 'downloadjs'
import rdPdf from '../static/MaterialComposer_Template.pdf'
import ImageWall_Winery from '../static/Support/ImageWall_Winery.jpg'

import { PDFDocument, rgb, StandardFonts, PDFString, PDFName, } from 'pdf-lib'
import  AvatarClip  from '../static/Icons/AvatarClip.png'
import  Zahner_Render_Materials  from '../static/Zahner_Render_Materials.zip'
import Materials from '../collections/materials'
import {getDate} from '../components-logging/Logging-Utility'

let downloadCount = 0
let datetime = getDate().ymdDate

const downloadZip = () => {
  const imageURI = Zahner_Render_Materials;
  const link = document.createElement("a");
  link.download = "Zahner-Render-Materials.zip";
  link.href = imageURI;
  link.click();
}

const materialPage = (matString) => {
  const temp = Materials.filter(v => v.name === matString).map(choice => choice.link)
  
  return temp
}
const materialSpecPage = (matString) => {
  const temp = Materials.filter(v => v.name === matString).map(choice => choice.pdfLink)
  
  return temp
}


const createPageLinkAnnotation = (page, uri, rectLoc) =>
  page.doc.context.register(
    page.doc.context.obj({
      Type: 'Annot',
      Subtype: 'Link',
      // Rect: [0, 30, 40, 230],
      Rect: rectLoc,
      Border: [0, 0, 0], //boarder width
      // Border: [1, 1, 1], //boarder width
      // C: [0, 0, 0],//255], //color
      C: [255, 255, 255], //color
      A: {
        Type: 'Action',
        S: 'URI',
        URI: PDFString.of(uri),
      },
    }),
  );

  const addMaterialpdf = async (pdfDoc, imgUrl) => {
    const imgBytes = await fetch(imgUrl).then((res) => res.arrayBuffer())
    // console.log(imgBytes)
    const pngImage = await pdfDoc.embedJpg(imgBytes)
    pngImage.scale(0.5)

    return pngImage
  }


  const addAvatarOther = (page,img, namy, dims, fontSize, font, y , avatarSize) => {
    const x1S = (150  + 50) 
    const y1S = dims - (295  + y)

    page.drawText(namy, {
      x: x1S,
      y: y1S ,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    })

    page.drawImage(img, {
      x: (100),
      y: (y1S - (fontSize)),
      width: avatarSize,
      height: avatarSize,
    })

    page.drawCircle({
      x: 100+(avatarSize/2),
      y: (y1S - (fontSize))+(avatarSize/2),
      size: avatarSize/2,
      borderWidth: 3,
      borderColor: rgb(1, 1, 1),
      opacity: 0,
      borderOpacity: 1,
    })

  }


  const addAvatarZahner = (page,img, namy,link, dims, fontSize, font, y , avatarSize) => {
    const x1S = (150  + 50) 
    const y1S = dims - (155  + y)
    const yTert = y1S +5
    const x2S = x1S + (15 * (12))
    const y2S = yTert - 2
    let specSheetList = []


    page.drawText(namy, {
      x: x1S,
      y: y1S + (avatarSize/2)-10,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    })

    const specSheet = materialSpecPage(namy)

    if (specSheet.length >0) {

      page.drawText("See The Product Sheet", {
      x: x1S,
      y: yTert,
      size: 12,
      font: font,
      color: rgb(0.93, 0.09, 0),
      })
      specSheetList.push(createPageLinkAnnotation(page, specSheet[0], [x1S, yTert+12, x2S, y2S]))

    }

    page.drawText("See More About this Patina", {
    x: x1S,
    y: yTert-(12+3),
    size: 12,
    font: font,
    color: rgb(0.93, 0.09, 0),
    })

    page.drawImage(img, {
      x: (100),
      y: (y1S - (fontSize)),
      width: avatarSize,
      height: avatarSize,
    })

    page.drawCircle({
      x: 100+(avatarSize/2),
      y: (y1S - (fontSize))+(avatarSize/2),
      size: avatarSize/2,
      borderWidth: 3,
      borderColor: rgb(1, 1, 1),
      opacity: 0,
      borderOpacity: 1,
    })

    specSheetList.push(createPageLinkAnnotation(page, link, [x1S, yTert-3, x2S+12, y2S-17]))

   
    return specSheetList;
    

  }


async function embedImages( UrlBoard, UrlRoom, UrlLand, avatObj, urlConfig) {
  const existingPdfBytes = await fetch(rdPdf).then((res) => res.arrayBuffer())
  const templatePdfDoc = await PDFDocument.load(existingPdfBytes)
  
  const matCompDoc = await PDFDocument.create();
  const helveticaFont = await matCompDoc.embedFont(StandardFonts.Helvetica)
  const templatePages = await matCompDoc.copyPages(templatePdfDoc, [0,1,2,3])
  const [firstPage, secondPage, thirdPage, lastPage] = templatePages

  matCompDoc.addPage(firstPage)
  matCompDoc.addPage(secondPage)
  matCompDoc.addPage(thirdPage)
  matCompDoc.addPage(lastPage)

  const boardImageBytes = await fetch(UrlBoard).then((res) => res.arrayBuffer())
  const roomImageBytes = await fetch(UrlRoom).then((res) => res.arrayBuffer())
  const landImageBytes = await fetch(UrlLand).then((res) => res.arrayBuffer())
  const primImageBytes = await fetch(avatObj.primeImage).then((res) => res.arrayBuffer())
  const secImageBytes = await fetch(avatObj.secImage).then((res) => res.arrayBuffer())
  const ImageWall_WineryBytes = await fetch(ImageWall_Winery).then((res) => res.arrayBuffer())
  // let perfImageBytes
  // if(avatObj.perState) {  perfImageBytes = await fetch(avatObj.perfImg).then((res) => res.arrayBuffer())}
  // console.log('roomImageBytes', roomImageBytes)

  const boardpngImage = await matCompDoc.embedPng(boardImageBytes)
  const roompngImage = await matCompDoc.embedPng(roomImageBytes)
  const landpngImage = await matCompDoc.embedPng(landImageBytes)
  const primpngImage = await matCompDoc.embedJpg(primImageBytes)
  const secpngImage = await matCompDoc.embedJpg(secImageBytes)
  const ImageWall_WineryImage = await matCompDoc.embedJpg(ImageWall_WineryBytes)
  // let perfpngImage
  // if(avatObj.perState) { perfpngImage = await matCompDoc.embedJpg(perfImageBytes)}

  const boardDims = boardpngImage.scale(0.67)
  const roomDims = roompngImage.scale(0.67)
  const landDims = landpngImage.scale(0.67)
  primpngImage.scale(0.3)
  const secDims = secpngImage.scale(0.3)

  const woodpngImage = await addMaterialpdf(matCompDoc,avatObj.woodImage)
  
  const tilepngImage = await addMaterialpdf(matCompDoc,avatObj.tileImage)
  const industrypngImage = await addMaterialpdf(matCompDoc,avatObj.industryImage)

  

  
  //  page resources --------------------------------------------------------
  const height  = thirdPage.getSize().height
  const fontSize = 22
  const fontSizeMed = 12
 
  //first page views------------------------------------------------------------

  
  firstPage.drawText("[Session Date: " + datetime + "]", {
    x: 260,
    y: 245,
    size: fontSize,
    font: helveticaFont,
    color: rgb(0.75,0.75,0.75),
  })

  // console.log('urlConfig', urlConfig)
  firstPage.drawText("Click to relaunch Session", {
    x: 260,
    y: 220,
    size: fontSize,
    font: helveticaFont,
    color: rgb(0.75,0.75,0.75),
  })

  const pageOnelink = createPageLinkAnnotation(thirdPage, urlConfig, [260, 215+fontSize, 650, 220]);
  firstPage.node.set(PDFName.of('Annots'), matCompDoc.context.obj([pageOnelink]));

  //second page views------------------------------------------------------------
  const topOffset = 225
  secondPage.drawImage(boardpngImage, {
    x: (secondPage.getWidth() / 2) - (boardDims.width / 2) -350,
    y: secondPage.getHeight() / 2 - boardDims.height + topOffset,
    width: boardDims.width,
    height: boardDims.height,
  })

  secondPage.drawImage(roompngImage, {
    x: (secondPage.getWidth() / 2) - (roomDims.width / 2) + 0,
    y: (secondPage.getHeight() / 2) - (roomDims.height) + topOffset,
    width: roomDims.width,
    height: roomDims.height,
  })

  secondPage.drawImage(landpngImage, {
    x: (secondPage.getWidth() / 2) - (landDims.width / 2) + 350,
    y: (secondPage.getHeight() / 2) - (landDims.height) + topOffset,
    width: landDims.width,
    height: landDims.height,
  })


  // third page resources --------------------------------------------------------
  const avatarSize = 60

  let linkSec

  const link = addAvatarZahner(thirdPage, primpngImage, avatObj.primeName, avatObj.primLink, height, fontSize, helveticaFont, -5, avatarSize )
  
  const ZLink = []

  ZLink.push(link[0])
  if(link.length>1){ ZLink.push(link[1])}


  if (avatObj.primeName !== avatObj.secName){
    linkSec = addAvatarZahner(thirdPage, secpngImage, avatObj.secName, avatObj.secLink, height, fontSize, helveticaFont, 84, avatarSize )
    // console.log('sec', linkSec)
    ZLink.push(linkSec[0])
    if(linkSec.length>1){ ZLink.push(linkSec[1])}
  }

  /// -------------------- Draw other Materials ----------------------
  // console.log('woodpngImage', woodpngImage)
  addAvatarOther(thirdPage, woodpngImage, avatObj.woodName, height, fontSize, helveticaFont, 32, avatarSize )
  addAvatarOther(thirdPage, tilepngImage, avatObj.tileName, height, fontSize, helveticaFont, 130, avatarSize )
  addAvatarOther(thirdPage, industrypngImage, avatObj.industryName, height, fontSize, helveticaFont, 225, avatarSize )

  

  const x1Sp =(470)
  const y1Sp =(100)
  const x2Sp = x1Sp + (150 + secDims.width) 
  const y2Sp = y1Sp 
  
  
  thirdPage.drawText("Interested in Perf - Explore Imagewall", {
    x: x1Sp,
    y: y1Sp,
    size: fontSizeMed,
    font: helveticaFont,
    color: rgb(0.93, 0.09, 0),
  })

  ImageWall_WineryImage.scale(.25)
  thirdPage.drawImage(ImageWall_WineryImage, {
    x: x1Sp,
    y: (125),
    width: ImageWall_WineryImage.width/4,
    height: ImageWall_WineryImage.height/4,
  })


  const linkPerf = createPageLinkAnnotation(thirdPage, 'https://www.azahner.com/products/imagewall/', [ x1Sp,y1Sp+12, x2Sp, y2Sp]);
  ZLink.push(linkPerf)
  thirdPage.node.set(PDFName.of('Annots'), matCompDoc.context.obj(ZLink));
  
  
  const pdfBytes = await matCompDoc.save()
  download(pdfBytes, `${datetime}_MaterialComposer.pdf`, 'application/pdf')
  return false
}

const imageMaskFunc = async (imageurl, backColor, wid) => {
  
  const image = await Jimp.read(imageurl)
  image.resize(wid, Jimp.AUTO)
  image.composite(backColor, 0, 0, {mode: Jimp.BLEND_DESTINATION_OVER, opacitySource: 1.0, opacityDest: 1.0,})
  image.invert()
  return image
}

const imageTile = async (image) => {
  const tile = await Jimp.read(image)
  const wid = 100
  tile.resize( wid, Jimp.AUTO)
  var tilesX = 700 / wid //1500
  var tilesY = 875 / 75

  var targetImage = await new Jimp(700, 1000)

  for (var x = 0; x < tilesX; ++x) {
    for (var y = 0; y < tilesY; ++y) {
      targetImage.composite(tile, 100 * x, 100 * y, {
        mode: Jimp.BLEND_DESTINATION_OVER,
        opacitySource: 1.0,
        opacityDest: 1.0,
      })
    }
  }
  return targetImage
}

const imageTileLand = async (image) => {
  const tile = await Jimp.read(image)
  const wid = 100
  const hig = 100
  tile.resize( wid, Jimp.AUTO)
  var tilesX = 700 / wid //1500
  var tilesY = 875 / hig

  var targetImage = await new Jimp(700, 1000)

  for (var x = 0; x < tilesX; ++x) {
    for (var y = 0; y < tilesY; ++y) {
      targetImage.composite(tile, wid * x, hig * y, {
        mode: Jimp.BLEND_DESTINATION_OVER,
        opacitySource: 1.0,
        opacityDest: 1.0,
      })
    }
  }
  targetImage.crop( 0, 0, 500, 500*5/4 ) //4/5
  return targetImage
}

const imageTileRot = async (image, deg=30) => {
  const rotImg = await imageTile(image)
  rotImg.rotate(deg)
  rotImg.crop( 0, 0, 500, 500*5/4 ) //4/5
  return rotImg
}

const getAvatar = async (image, clip, backMask) => {
  const ZImage = await Jimp.read(image)
  ZImage.resize(200, Jimp.AUTO)
  ZImage.mask(clip)
  ZImage.composite(backMask, 0, 0, { mode: Jimp.BLEND_DESTINATION_OVER, opacitySource: 1.0,  opacityDest: 1.0, })

  return ZImage
}

// const JimpImage = async (setSpinner, asyncLogParams, urlConfig, limitDowload,  imageName='believe') => {
const JimpImage = async (setSpinner, asyncLogParams, urlConfig, limitDowload,  imageName='believe') => {
  console.log('Downloading')

  const widthImg = 500
  const RoomLayout = document.getElementById('RoomLayout')
  const RoomLayoutChild = document.getElementById('RoomLayoutChild')
  const board = document.getElementById('board')
  const landscapeLayout = document.getElementById('LandscapeLayout')
  const landscapeLayoutChild = document.getElementById('LandLayoutChild')
  const materialAvatar = document.getElementsByClassName('MuiAvatar-img')
  const matAvatarZprim = materialAvatar[0]
  const matAvatarZSec = materialAvatar[1]
  const matAvatarWood = materialAvatar[2]
  const matAvatarTile = materialAvatar[4]
  const matAvatarIndustry= materialAvatar[5]

  // //Board
  document.getElementById('radioBoard').style.visibility = 'hidden'
  const boardImage = await domtoimage.toBlob(board)
  document.getElementById('radioBoard').style.visibility = 'visible'
  const boardBlobImageurl = URL.createObjectURL(boardImage)
  
  // console.log(boardZprime)

  // ////////////////////////////////////////////////////////////////////////////////////////Material Avatar ////////////////////////////////////////////
  
  const backMask = await new Jimp(200, 200, '#FFFFFFFF')
  const backMaskAvatar = await new Jimp(200, 200, '#F0E9F5')
  const AvatarClipJimp = await imageMaskFunc(AvatarClip, backMask, 200 )
  AvatarClipJimp.invert()

  const zPrimeName = matAvatarZprim.alt
  const ZprimeImage = await getAvatar(matAvatarZprim.src, AvatarClipJimp, backMaskAvatar)
  const zSecName = matAvatarZSec.alt
  const ZSecImage = await getAvatar(matAvatarZSec.src, AvatarClipJimp, backMaskAvatar)
  const woodName = matAvatarWood.alt
  const woodImage = await getAvatar(matAvatarWood.src, AvatarClipJimp, backMaskAvatar)
  const tileName = matAvatarTile.alt
  const tileImage = await getAvatar(matAvatarTile.src, AvatarClipJimp, backMaskAvatar)
  const industryName = matAvatarIndustry.alt
  const industryImage = await getAvatar(matAvatarIndustry.src, AvatarClipJimp, backMaskAvatar)



  const matAvatarObj = {
    primeName: zPrimeName,
    primeImage: ZprimeImage,
    primLink: materialPage(zPrimeName)[0],
    secName: zSecName,
    secImage: ZSecImage,
    secLink: materialPage(zSecName)[0],
    perState: false,
    perfImg: ZprimeImage,
    woodName: woodName,
    woodImage: woodImage,
    tileName: tileName,
    tileImage: tileImage,
    industryName: industryName,
    industryImage: industryImage,
  }


  ////////////////////////////////////////////////////////////////////////////////////////// get materials///////////////////////////////////////////////
  const zahner1 = RoomLayoutChild.childNodes[2].firstChild.style.backgroundImage.slice(5,-2)
  const zahner2 = RoomLayoutChild.childNodes[3].firstChild.style.backgroundImage.slice(5,-2)
  const wood = RoomLayoutChild.childNodes[4].innerText
  const tile = RoomLayoutChild.childNodes[7].innerText
  const Industry = RoomLayoutChild.childNodes[8].innerText
  // console.log('RoomLayoutChild', zahner1, )



  ////////////////////////////////////////////////////////////////////////////////////////// get board masks///////////////////////////////////////////////////
  const fontConstant = parseFloat(getComputedStyle(document.documentElement).fontSize)
  const perfBool = board.firstChild.firstChild.firstChild.firstChild.firstChild.id//.style//aria-haspopup
  // const matRef = board.firstChild.firstChild.firstChild.childNodes//.style//aria-haspopup
  const natureRef = board.firstChild.firstChild.firstChild.childNodes[3]
  const natureimg = natureRef.firstChild.firstChild.src
  const naturewidth =  parseFloat(natureRef.firstChild.firstChild.style.width.slice(0,-3)) * fontConstant
  // const natureHeight =  'auto'
  const tileRef = board.firstChild.firstChild.firstChild.childNodes[4]
  const tileimg = tileRef.firstChild.firstChild.src
  const tileWidth =  parseFloat(tileRef.firstChild.firstChild.style.width.slice(0,-3))
  // const tileHeight =  parseFloat(natureRef.firstChild.firstChild.style.height.slice(0,-3)) * fontConstant
  const tileHeight =  parseFloat(tileRef.firstChild.firstChild.style.height.slice(0,-3))


  let zprimX, zprimY, boardZprimeImgJimp, boardZNatureImgJimp, nX, nY, boardTileImgJimp, tX, tY, stringEdit, boardZprimeMaskJimp, boardZprimeMaskJimpIW

  if (perfBool === 'mask'){
    const boardZprime = board.firstChild.firstChild.firstChild.firstChild
    const boardZprimeImg = boardZprime.firstChild.firstChild.firstChild.src
    const width = parseFloat(boardZprime.firstChild.firstChild.firstChild.style.width.slice(0,-3)) * (fontConstant * 5)
    // const width = parseFloat(boardZprime.firstChild.firstChild.firstChild.style.width.slice(0,-3)) * fontConstant
    
    boardZprimeImgJimp = await Jimp.read(boardZprimeImg)
    boardZprimeMaskJimpIW = boardZprimeImgJimp.clone()
    const boardZprimeMask = boardZprime.firstChild.firstChild.style.webkitMaskImage.slice(5,-2)
    boardZprimeMaskJimp = await Jimp.read(boardZprimeMask)
  
    stringEdit = boardZprime.style.transform
    const boardZprimestyle = stringEdit.replace(/translate\(|px|,|\)/gi, '').split(' ');
    [zprimX, zprimY] = boardZprimestyle.map((val) => parseFloat(val)  )
    boardZprimeImgJimp.resize(1170, Jimp.AUTO)
    boardZprimeImgJimp.mask(boardZprimeMaskJimp.invert(),0,0)
    boardZprimeImgJimp.resize(width, Jimp.AUTO)
    boardZprimeMaskJimpIW.mask(boardZprimeMaskJimp,0,0)
    boardZprimeMaskJimpIW.resize(width, Jimp.AUTO)

    boardZNatureImgJimp = await Jimp.read(natureimg)
    boardZNatureImgJimp.resize(naturewidth, Jimp.AUTO)
    stringEdit = natureRef.style.transform
    const boardNaturestyle = stringEdit.replace(/translate\(|px|,|\)/gi, '').split(' ');
    [nX, nY] = boardNaturestyle.map((val) => parseFloat(val)  )

    boardTileImgJimp = await Jimp.read(tileimg)
    boardTileImgJimp.resize(tileWidth, tileHeight)
    stringEdit = tileRef.style.transform
    const boardTilestyle = stringEdit.replace(/translate\(|px|,|\)/gi, '').split(' ');
    [tX, tY] = boardTilestyle.map((val) => parseFloat(val)  )


  }
  
  ////////////////////////////////////////////////////////////////////////////////////////// get Room masks///////////////////////////////////////////////////
  const zahner1iMaskImg = document.getElementById('roomZahner1Mask').style.webkitMaskImage.slice(5,-2)
  const zahner2iMaskImg = RoomLayoutChild.childNodes[3].style.webkitMaskImage.slice(5,-2)
  const woodiTopMaskImg = RoomLayoutChild.childNodes[5].style.webkitMaskImage.slice(5,-2)
  const woodiSideMaskImg = RoomLayoutChild.childNodes[6].style.webkitMaskImage.slice(5,-2)
  const woodiFrontMaskImg = RoomLayoutChild.childNodes[4].style.webkitMaskImage.slice(5,-2)
  const tileiMaskImg = RoomLayoutChild.childNodes[7].style.webkitMaskImage.slice(5,-2)
  const industryiMaskImg = RoomLayoutChild.childNodes[8].style.webkitMaskImage.slice(5,-2)
  const perfMaskImg = RoomLayoutChild.childNodes[9].firstChild.style.webkitMaskImage.slice(5,-2)

  ///////// get Room base, enteruouge, nature ///////////////////////////////////////////////////
  const roomBase = RoomLayout.getElementsByTagName('img')[0].src
  const roomMultiply = RoomLayout.getElementsByTagName('img')[1].src
  const roomEnteruouge = RoomLayout.getElementsByTagName('img')[2].src
  const roomNature = RoomLayout.getElementsByTagName('img')[3].src
  // console.log('RoomLayout ', RoomLayoutChild.childNodes)

  ///////// get Landscape masks///////////////////////////////////////////////////  
  const zahner1LandMaskImg = landscapeLayoutChild.childNodes[2].style.webkitMaskImage.slice(5,-2)
  const zahner2LandMaskImg = landscapeLayoutChild.childNodes[3].style.webkitMaskImage.slice(5,-2)
  const woodLandMaskImg = landscapeLayoutChild.childNodes[4].style.webkitMaskImage.slice(5,-2)
  const tileLandMaskImg = landscapeLayoutChild.childNodes[5].style.webkitMaskImage.slice(5,-2)
  const industryLandMaskImg = landscapeLayoutChild.childNodes[6].style.webkitMaskImage.slice(5,-2)
  // console.log('LandscapeLayoutMasks ', zahner1LandMaskImg, 'n',zahner2LandMaskImg,'n', woodLandMaskImg, 'n',tileLandMaskImg, 'n',industryLandMaskImg, 'n',)

  ///////// get Landscape base, enteruouge, nature ///////////////////////////////////////////////////
  const landBase = landscapeLayout.getElementsByTagName('img')[0].src
  const LandMultiply = landscapeLayout.getElementsByTagName('img')[1].src
  const LandEnteruouge = landscapeLayout.getElementsByTagName('img')[2].src
  const LandNature = landscapeLayout.getElementsByTagName('img')[3].src
  // console.log('maskRot', '\n', )

  /////////////////////////////////////////////////// Material setup /////////////////////////////////////////
  const zahner1Tiled = await imageTile(zahner1)
  const zahner2Tiled = await imageTile(zahner2)
  const woodTiledFront = await imageTileRot(wood, -27)
  const woodTiledTop = await imageTileRot(wood, 27)
  const woodTiledSide  = await imageTileRot(wood, 27)
  const tileTiled = await imageTile(tile)
  const IndustryTiled = await imageTile(Industry)
  const zahner1PerfTiled = zahner1Tiled.clone()


  const landzahner1Tiled = await imageTileLand(zahner1)
  const landzahner1TiledBlur = landzahner1Tiled.clone()
  landzahner1TiledBlur.rotate(45)
  landzahner1TiledBlur.resize(1000, Jimp.AUTO)
  landzahner1Tiled.composite(landzahner1TiledBlur, -250, -250, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.7, opacityDest: 1.0, })

  const landzahner2Tiled = await imageTileLand(zahner2)
  const landzahner2TiledBlur = landzahner2Tiled.clone()
  landzahner2TiledBlur.rotate(30)
  landzahner2TiledBlur.resize(1000, Jimp.AUTO)
  landzahner2Tiled.composite(landzahner2TiledBlur, -250, -250, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.7, opacityDest: 1.0, })

  const landwoodTiled  = await imageTileRot(wood, 0)
  const landtileTiled = tileTiled.clone()
  const landIndustryTiled = IndustryTiled.clone()


  


  /////////////////////////////////////////////////////////Room///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  // // //get context
  const roomImagebase = await Jimp.read(roomBase)
  roomImagebase.resize(widthImg, Jimp.AUTO)
  const roomImagemultiply = await Jimp.read(roomMultiply)
  roomImagemultiply.resize(widthImg, Jimp.AUTO)
  const roomEnteruougeImg = await Jimp.read(roomEnteruouge)
  roomEnteruougeImg.resize(widthImg, Jimp.AUTO)
  const roomNatureImg = await Jimp.read(roomNature)
  roomNatureImg.resize(widthImg, Jimp.AUTO)

  // //helpers
  var back = await new Jimp(widthImg, roomImagebase.getHeight(), '#FFFFFFFF')
  
  // //setup masks
  const roomzahner1iMaskImg = await imageMaskFunc(zahner1iMaskImg, back, widthImg )
  const roomzahner2iMaskImg = await imageMaskFunc(zahner2iMaskImg, back, widthImg )
  const roomwoodiFrontMaskImg = await imageMaskFunc(woodiFrontMaskImg, back, widthImg )
  const roomwoodiTopMaskImg = await imageMaskFunc(woodiTopMaskImg, back, widthImg )
  const roomwoodiSideMaskImg = await imageMaskFunc(woodiSideMaskImg, back, widthImg )
  const roomtileiMaskImg = await imageMaskFunc(tileiMaskImg, back, widthImg )
  const roomindustryiMaskImg = await imageMaskFunc(industryiMaskImg, back, widthImg )
  let roomPerfiMaskImg
  if(perfMaskImg !== 'undefined'){ roomPerfiMaskImg = await imageMaskFunc(perfMaskImg, back, widthImg )}

  

  //Apply masks
  zahner1Tiled.mask(roomzahner1iMaskImg, 0, 0)
  zahner2Tiled.mask(roomzahner2iMaskImg, 0, 0)
  
  woodTiledFront.mask(roomwoodiFrontMaskImg, 0, 0)
  woodTiledTop.mask(roomwoodiTopMaskImg, 0, 0)
  woodTiledSide.mask(roomwoodiSideMaskImg, 0, 0)
  tileTiled.mask(roomtileiMaskImg, 0, 0)
  IndustryTiled.mask(roomindustryiMaskImg, 0, 0)
  if(perfMaskImg !== 'undefined'){zahner1PerfTiled.mask(roomPerfiMaskImg, 0, 0)}


  // // assemble room
  roomImagebase.composite(zahner1Tiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(zahner2Tiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(woodTiledFront, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(woodTiledTop, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(woodTiledSide, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(tileTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  roomImagebase.composite(IndustryTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })
  if(perfMaskImg !== 'undefined'){roomImagebase.composite(zahner1PerfTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0,  opacityDest: 1.0, })}

  roomImagebase.composite(roomEnteruougeImg, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })
  roomImagebase.composite(roomNatureImg, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })

  roomImagebase.composite(roomImagemultiply, 0, 0, {
    mode: Jimp.BLEND_MULTIPLY,
    opacitySource: 1.0,
    opacityDest: 1.0,
  })

  //////////////////////////////////////////////////Landscape//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //get context
  const landImagebase = await Jimp.read(landBase)
  landImagebase.resize(widthImg, Jimp.AUTO)
  const landmagemultiply = await Jimp.read(LandMultiply)
  landmagemultiply.resize(widthImg, Jimp.AUTO)
  const landnteruougeImg = await Jimp.read(LandEnteruouge)
  landnteruougeImg.resize(widthImg, Jimp.AUTO)
  const landNatureImg = await Jimp.read(LandNature)
  landNatureImg.resize(widthImg, Jimp.AUTO)

  // //setup masks

  const landzahner1iMaskImg = await imageMaskFunc(zahner1LandMaskImg, back, widthImg )
  const landzahner2iMaskImg = await imageMaskFunc(zahner2LandMaskImg, back, widthImg )
  const landwoodiFrontMaskImg = await imageMaskFunc(woodLandMaskImg, back, widthImg )
  const landtileiMaskImg = await imageMaskFunc(tileLandMaskImg, back, widthImg )
  const landindustryiMaskImg = await imageMaskFunc(industryLandMaskImg, back, widthImg )

  // //Apply masks
  landzahner1Tiled.mask(landzahner1iMaskImg, 0, 0)
  landzahner2Tiled.mask(landzahner2iMaskImg, 0, 0)
  
  landwoodTiled.mask(landwoodiFrontMaskImg, 0, 0)
  landtileTiled.mask(landtileiMaskImg, 0, 0)
  landIndustryTiled.mask(landindustryiMaskImg, 0, 0)

  // // assemble Land scene
  landImagebase.composite(landmagemultiply, 0, 0, { mode: Jimp.BLEND_MULTIPLY, opacitySource: 0.5,  opacityDest: 0.9,  })


  landImagebase.composite(landzahner1Tiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.5, opacityDest: 1.0, })
  landImagebase.composite(landzahner1Tiled, 0, 0, { mode: Jimp.BLEND_MULTIPLY, opacitySource: .6, opacityDest: 1.0, })
  landImagebase.composite(landzahner2Tiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.5, opacityDest: 1.0, })
  landImagebase.composite(landzahner2Tiled, 0, 0, { mode: Jimp.BLEND_MULTIPLY, opacitySource: .6, opacityDest: 1.0, })
  landImagebase.composite(landwoodTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.7, opacityDest: 1.0, })
  landImagebase.composite(landwoodTiled, 0, 0, { mode: Jimp.BLEND_MULTIPLY, opacitySource: 0.5, opacityDest: 1.0, })
  landImagebase.composite(landtileTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 0.7, opacityDest: 1.0, })
  landImagebase.composite(landIndustryTiled, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })

  landImagebase.composite(landnteruougeImg, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })
  landImagebase.composite(landNatureImg, 0, 0, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })

  landImagebase.composite(landmagemultiply, 0, 0, {
    // mode: Jimp.BLEND_DESTINATION_OVER,
    mode: Jimp.BLEND_MULTIPLY,
    opacitySource: 0.9,
    opacityDest: 1.0,
  })

  // // ///quick download
  // boardZprimeImgJimp.getBase64(Jimp.AUTO, function (err, data) {

  //   var a = document.createElement('a')
  //   a.setAttribute('download', `${imageName}.png`)
  //   a.setAttribute('href', data)
  //   a.click()
  // })
  // boardZprimeMaskJimp.getBase64(Jimp.AUTO, function

  // //Board
  const boardImageJimp = await Jimp.read(boardBlobImageurl)

  if (perfBool === 'mask') {
    const size = 300
    const PerfBack = await new Jimp(size, size, '#FFFFFFFF')
    const boardZprimeImgJimp2 = boardZprimeImgJimp.clone()
    

    boardZprimeImgJimp.resize(200,200)
    boardImageJimp.composite(boardZprimeImgJimp, zprimX, zprimY, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })
    boardImageJimp.composite(boardTileImgJimp, tX, tY, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })
    
    boardImageJimp.composite(boardZNatureImgJimp, nX, nY, { mode: Jimp.BLEND_SOURCE_OVER, opacitySource: 1.0, opacityDest: 1.0, })

    boardZprimeImgJimp2.resize(size,size)
    boardZprimeImgJimp2.composite(PerfBack, 0, 0, { mode: Jimp.BLEND_DESTINATION_OVER, opacitySource: 1.0, opacityDest: 1.0, })
    matAvatarObj.perState = true
    matAvatarObj.perfImg = await boardZprimeImgJimp2.getBase64Async(Jimp.AUTO)
    
    
  }
  
  boardImageJimp.resize(500, Jimp.AUTO)
  const boardImageJimpImageurl = await boardImageJimp.getBase64Async(Jimp.AUTO)
  

  ////room 
  const roomImageurl = await roomImagebase.getBase64Async(Jimp.AUTO)

  ////Landscape
  const LandImageurl = await landImagebase.getBase64Async(Jimp.AUTO)
  
  // third page elements
  matAvatarObj.primeImage = await ZprimeImage.getBase64Async(Jimp.AUTO)
  matAvatarObj.secImage = await ZSecImage.getBase64Async(Jimp.AUTO)
  matAvatarObj.woodImage = await woodImage.getBase64Async(Jimp.AUTO)
  matAvatarObj.tileImage = await tileImage.getBase64Async('image/jpeg')
  matAvatarObj.industryImage = await industryImage.getBase64Async(Jimp.AUTO)

  let embedFinished = true
  // console.log (urlConfig)
  embedFinished =  await embedImages( boardImageJimpImageurl, roomImageurl, LandImageurl, matAvatarObj, urlConfig)
  downloadCount += 1
  asyncLogParams("downloads", downloadCount, JSON.stringify({Prim: zPrimeName, Sec: zSecName }))
  

  if (embedFinished === false){
    if(!limitDowload){
      downloadZip()
    }
    setSpinner(false)
  }
  
}

export default JimpImage
